import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { UserSessionDataForm } from '../_models/login/user-session-data-form';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { NgZone } from '@angular/core/';
import { Router, ActivatedRoute } from '@angular/router';
import { ServerInfoDataForm } from '../_models/ServerInfoDataForm';
import { LoginForm } from '../_models/login-form';
import { ForgotPasswordForm } from '../_models/forgot-password-form';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AuthService {

  public static readonly SECURITY_CONTROLLER = environment.apiUrl + '/security';
  public static readonly URL_POST_LOGIN = AuthService.SECURITY_CONTROLLER + '/login';
  public static readonly URL_POST_CHECK_SESSION = AuthService.SECURITY_CONTROLLER + '/token/checkSession';

  public static readonly CHANGE_PASSWORD_URL = environment.apiUrl + '/users/changePassword/';
  public static readonly FORGOT_PASSWORD_URL = environment.apiUrl + '/users/forgotPassword/';

  // security/token/checkSession/
  constructor(private http: HttpClient, private zone: NgZone,
    private route: ActivatedRoute, private router: Router) { }


  login(loginForm: LoginForm): Observable<HttpResponse<UserSessionDataForm>> {
    this.removeToken();
    const dataForm = JSON.stringify(loginForm);
    return this.http.post<UserSessionDataForm>(AuthService.URL_POST_LOGIN, loginForm, { observe: 'response' })
      .pipe(map(response => {
        if (response.status === 200) {
          localStorage.setItem('currentUser', JSON.stringify(response.body));
          this.reloadPage();
        }
        return response;
      }));
  }

  getUserData() {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser != null) {
      const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
      return currentUserJson;
      // if (currentUserJson.userRoleId > 0) {
      //   return currentUserJson;
      // } else {
      //   this.removeToken();
      //   return null;
      // }
    } else {
      this.router.navigate(['/login']);
      return null;
    }
  }

  getUserToken() {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser != null) {
      const currentUserJson = JSON.parse(currentUser);
      if (currentUserJson.userToken && currentUserJson.userToken !== '') {
        return currentUserJson.userToken;
      } else {
        this.removeToken();
        this.router.navigate(['/login']);
        return false;
      }
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  /**
	  * Check token for given user
	  * @param username
	  * @param token
	 */
  public checkTokenData() {
    const currentUser = localStorage.getItem('currentUser');
    let tokenData = '';
    if (currentUser != null) {
      const currentUserJson = JSON.parse(currentUser);
      tokenData = currentUserJson.userToken;
    }
    const urlTemp = AuthService.URL_POST_CHECK_SESSION + '/' + tokenData;

    return this.http.get(urlTemp)
      .pipe(catchError(this.handleError('Request Failed')));


    // return this.http.get(urlTemp)
    //   .map(resp => {
    //     const userSession = resp as UserSessionDataForm;
    //     localStorage.setItem('currentUser', JSON.stringify(userSession));
    //   });
  }

  checkUserSession() {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser != null) {
      const currentUserJson = JSON.parse(currentUser);
      if (currentUserJson.userId) {
        return true;
      } else {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.router.navigate(['/login']);
        return false;
      }
    } else {
      this.router.navigate(['/login']);
      return false;
    }

  }

  removeToken() {
    localStorage.removeItem('currentUser');
    this.router.navigate(['/login']);
  }

  reloadPage() { 
    // click handler or similar
    this.zone.runOutsideAngular(() => {
      // location.reload();
      window.location.replace('');
    });
  }

  reloadPageByUrl(url) { // click handler or similar
    this.zone.runOutsideAngular(() => {
      // location.reload();
      window.location.replace(url);
    });
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    // window.location.replace('/logout');
    // this.router.navigate(['/login']);
    window.location.replace('http://ipat.dexpatent.com/');
  }

  getServerDate(): Observable<HttpResponse<ServerInfoDataForm>> {
    const urlToCall = AuthService.SECURITY_CONTROLLER + '/date/' + this.getUserToken();
    return this.http.get<ServerInfoDataForm>(urlToCall, { observe: 'response' })
      .pipe(catchError(this.handleError('Request Failed')));

  }

  /**
    * Save forgotPassword
    * @param emailId
    */
  // forgotPassword(emailId: string) {

  //   return this.http.get(AuthService.FORGOT_PASSWORD_URL + '/' + emailId)
  //       .map((response: Response) => response.json());
  // }

  forgotPassword(forgotPasswordForm: ForgotPasswordForm) {

    // return this.http.get(AuthService.FORGOT_PASSWORD_URL + '/' + forgotPasswordForm)
    //     .map((response: Response) => response.json());
    return this.http.post(AuthService.FORGOT_PASSWORD_URL, forgotPasswordForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  /**
  * Save changePassword
  * @param id
  */
  changePassword(oldPassword: string, newPassword: string) {
    let userToken = this.getUserToken(); //  + '/' + userToken

    return this.http.get(AuthService.CHANGE_PASSWORD_URL + '/' + oldPassword + '/' + newPassword + '/' + userToken)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }

  // private handleError<T>(operation = 'operation') {
  //   return (error: HttpErrorResponse) => {
  //     console.log(`${operation} failed: ${error.message}`);
  //     this.removeToken();
  //     // if (error.status >= 400 && error.status < 500) {
  //     //   return Observable.throw(error.message);
  //     // } else {
  //     //   Observable.throw(new Error(error.message));
  //     // }
  //     return Observable.throw(error);
  //   };
  // }

}
